export default __webpack_public_path__ + "static/media/email icon 001.dc4aeff2.png";